import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d7b953e2"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "title",
  id: "devhistory"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_3 = { class: "title wow animate__backInDown" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_5 = { class: "title wow animate__backInDown" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_7 = { class: "title wow animate__backInDown" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_9 = {
  class: "title wow animate__backInDown",
  id: "culture"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))

import ComProfile from '@/components/aboutView/ComProfile.vue'
import DevHistory from '@/components/aboutView/DevHistory.vue'
import ComHonor from '@/components/aboutView/ComHonor.vue'
import RDTeam from '@/components/aboutView/RDTeam.vue'
import AboutLogo from '@/components/aboutView/AboutLogo.vue'
import ComCulture from '@/components/aboutView/ComCulture.vue'
import AboutBanner from '@/components/aboutView/AboutBanner.vue'
import WOW from 'wowjs'
import { onMounted, ref } from "vue"

export default /*#__PURE__*/_defineComponent({
  __name: 'AboutView',
  setup(__props) {

onMounted(() => {

  sessionStorage.setItem('activeIndex', '/about')

})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createVNode(AboutBanner),
      _createVNode(ComProfile, { id: "profile" }),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("p", null, _toDisplayString(_ctx.$t('subhistory')), 1),
        _createElementVNode("h1", null, _toDisplayString(_ctx.$t('DevHistory')), 1),
        _hoisted_2
      ]),
      _createVNode(DevHistory),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("p", null, _toDisplayString(_ctx.$t('SubHonor')), 1),
        _createElementVNode("h1", null, _toDisplayString(_ctx.$t('Com Honor')), 1),
        _hoisted_4
      ]),
      _createVNode(ComHonor),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("p", null, _toDisplayString(_ctx.$t('rdTeam')), 1),
        _createElementVNode("h1", null, _toDisplayString(_ctx.$t('R&D Team')), 1),
        _hoisted_6
      ]),
      _createVNode(RDTeam),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("p", null, _toDisplayString(_ctx.$t('LOGO')), 1),
        _createElementVNode("h1", null, _toDisplayString(_ctx.$t('subLogo')), 1),
        _hoisted_8
      ]),
      _createVNode(AboutLogo),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("p", null, _toDisplayString(_ctx.$t('subCulture')), 1),
        _createElementVNode("h1", null, _toDisplayString(_ctx.$t('rekeyCulture')), 1),
        _hoisted_10
      ])
    ]),
    _createVNode(ComCulture)
  ], 64))
}
}

})